import { render, staticRenderFns } from "./SerchAttractionsWithMap.vue?vue&type=template&id=5fa801e6&scoped=true"
import script from "./SerchAttractionsWithMap.vue?vue&type=script&lang=js"
export * from "./SerchAttractionsWithMap.vue?vue&type=script&lang=js"
import style0 from "./SerchAttractionsWithMap.vue?vue&type=style&index=0&id=5fa801e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa801e6",
  null
  
)

export default component.exports